module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('create-dialog', {
    attrs: {
      "dialog-visible": _vm.dialogFormVisible,
      "close-dialog": function (c) {
        _vm.dialogFormVisible = false
      }
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "10px 0px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    },
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('customer.create')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('base.deleteConfirm'),
      "size": "tiny"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('customer.deleteConfirmText')) + " " + _vm._s(_vm.selectedCustomer.name))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.deleteSelectedCustomer()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.confirm')))])], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.customers,
      "border": "border"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('customer.refCode'),
      "property": "refCode",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('customer.name'),
      "property": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('customer.groupName'),
      "property": "customerGroup.name",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "70"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-dropdown', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "trigger": "click",
            "size": "small"
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_c('i', {
          staticClass: "el-icon-more"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "size": "mini"
          },
          nativeOn: {
            "click": function($event) {
              _vm.navigate({
                name: 'customer.edit',
                params: {
                  id: _vm.customers[scope.$index].id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('base.edit')))]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "size": "mini"
          },
          nativeOn: {
            "click": function($event) {
              _vm.confirmDelete(_vm.customers[scope.$index])
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('base.delete')))])], 1)], 1)]
      }]
    ])
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "10px 0px",
      "text-align": "right"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, sizes, prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-074be2f7"}!./src/pages/customer/view/index.html
// module id = 795
// module chunks = 1